// extracted by mini-css-extract-plugin
export default {"heading":"TodoList_heading__Nj0tw"};